import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import FontAwesome from 'react-fontawesome';

const ConsultationBookingForm = ({ error, handleSubmit, pristine, submitting, t, children, centers }) => {

    return (
        <form onSubmit={handleSubmit} className='form-login'>
            {error && <Alert bsStyle='danger'>{error}</Alert>}
            <Field name='childId' component={Input} componentClass='select' label={t('FO_Booking_Child')} validate={validators.required}>
                {children && children.map(child => <option key={child.id} value={child.id}>{child.fullName}</option>)}
            </Field>
            <Field name='centerId' component={Input} componentClass='select' label={t('FO_Booking_Center')} validate={[validators.required]}>
                {centers && centers.map(center => <option key={center.id} value={center.id}>{center.name}</option>)}
            </Field>
            <div className='form-actions'>
                <Button type='submit' disabled={submitting} className='btn btn-primary'>
                    <FontAwesome name='plus' /> {t('FO_Booking_BookConsultation')}
                </Button>
            </div>
        </form>
    );
};

ConsultationBookingForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'consultationBooking', enableReinitialize: true })(withTranslation()(ConsultationBookingForm));